export enum ExampleDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP'
}
